/** Format date to YYYY-MM-DD */
export function formatDateId(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

/** Get today's date ID */
export function getTodayId(): string {
  return formatDateId(new Date());
}

/** Parse YYYY-MM-DD to Date */
export function parseDateId(dateId: string): Date | null {
  const parts = dateId.split("-");
  if (parts.length !== 3) return null;
  const [y, m, d] = parts.map((x) => Number(x));
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d, 0, 0, 0, 0);
}

/** Convert dateId to Date */
export function dateIdToDate(dateId: string): Date {
  const [y, m, d] = dateId.split("-").map((n) => parseInt(n, 10));
  return new Date(y, m - 1, d);
}

/** Add days to date */
export function addDays(date: Date, days: number): Date {
  const copy = new Date(date.getTime());
  copy.setDate(copy.getDate() + days);
  return copy;
}

/** Whole-day difference between date IDs */
export function diffInDays(fromDateId: string, toDateId: string): number {
  const a = dateIdToDate(fromDateId);
  const b = dateIdToDate(toDateId);
  const msInDay = 1000 * 60 * 60 * 24;
  return Math.floor((b.getTime() - a.getTime()) / msInDay);
}

/**
 * Calculate the current week number based on programme start date
 */
export function calculateCurrentWeek(startDateId: string): number {
  const start = parseDateId(startDateId);
  if (!start) return 1;
  
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  const diffTime = today.getTime() - start.getTime();
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  const weekNumber = Math.floor(diffDays / 7) + 1;
  
  return Math.max(1, Math.min(6, weekNumber));
}
/**
 * Check if a week is chronologically past based on programme start
 */
export function isWeekChronologicallyPast(weekNumber: number, startDateId: string): boolean {
  const start = parseDateId(startDateId);
  if (!start) return false;
  
  const weekStart = addDays(start, (weekNumber - 1) * 7);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  return today >= weekStart;
}
